var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuThresholds = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "tiny",
  id: "Thresholds_1_",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 24",
  overflow: "visible",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  fill: "#FFFFFF",
  points: "9.5,12.48 3.5,18.49 2,16.99 9.5,9.48 13.5,13.48 20.59,5.51 22,6.92  13.5,16.48 "
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuThresholds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Thresholds.30ef7986.svg";
export { ForwardRef as ReactComponent };